import React from 'react'
import {
  Box,
  Button,
  Divider,
  IconButton,
  Modal,
  Stack,
  Typography,
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { useTranslation } from 'react-i18next'

export default function ConfirmationModal(props: any) {
  const { t } = useTranslation('translation')
  return (
    <Modal
      open={props.show}
      onClose={props.onHide}
      sx={{ outline: 0 }}
      className="confirmation-modal"
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          width: props.size === 'lg' ? '600px' : '500px',
          maxWidth: '95vw',
          maxHeight: '80vh',
          bgcolor: 'background.paper',
          transform: 'translate(-50%, -50%)',
          borderRadius: '8px',
          overflow: 'hidden',
          p: 2,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {/* Header */}
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          {props.headerMessage && (
            <Typography
              variant="subtitle2"
              component="h3"
              sx={{ fontWeight: 700 }}
            >
              {props.headerMessage}
            </Typography>
          )}
          <IconButton onClick={props.onHide} size="small" sx={{ ml: 'auto' }}>
            <CloseIcon />
          </IconButton>
        </Stack>

        <Divider sx={{ my: 1 }} />

        {/* Body */}
        <Box
          sx={{
            flex: 1,
            overflowY: 'auto',
            py: 2,
            px: 2,
          }}
        >
          <Typography variant="body1" sx={{ fontWeight: 400 }}>
            {props.message}
          </Typography>
        </Box>

        {/* Footer */}
        <Divider sx={{ my: 2 }} />
        <Stack direction="row" justifyContent="center" gap={2}>
          <Button
            variant="outlined"
            color="primary"
            sx={{ flex: 1, textTransform: 'none' }}
            onClick={
              props.confirmOnHideHandler
                ? props.confirmOnHideHandler
                : props.onHide
            }
          >
            {props.secondaryButtonText
              ? props.secondaryButtonText
              : t('No, Cancel')}
          </Button>
          {props.confirmHandler && (
            <Button
              variant="outlined"
              color={props.positiveAction ? 'primary' : 'error'}
              sx={{ flex: 1, textTransform: 'none' }}
              onClick={e => props.confirmHandler(e)}
            >
              {props.buttonText ? props.buttonText : t('Yes, Delete')}
            </Button>
          )}
        </Stack>
      </Box>
    </Modal>
  )
}
